module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [(!_vm.isAsso) ? _c('div', [_c('div', {
    staticClass: "top-part"
  }, [(!_vm.isSaved) ? _c('div', {
    staticClass: "save",
    on: {
      "click": function($event) {
        return _vm.saveWord(true)
      }
    }
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('inline-svg', {
    staticClass: "save-svg",
    attrs: {
      "src": require('../../assets/svg/notsaved.svg').default
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("dictionary.box.save")))])]) : _vm._e(), _vm._v(" "), (_vm.isSaved) ? _c('div', {
    staticClass: "save",
    on: {
      "click": function($event) {
        return _vm.saveWord(false)
      }
    }
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('inline-svg', {
    staticClass: "save-svg",
    attrs: {
      "src": require('../../assets/svg/saved.svg').default
    }
  })], 1), _vm._v(" "), (_vm.isSaved) ? _c('p', [_vm._v(_vm._s(_vm.$t("dictionary.box.remove")))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "assosyazia",
    on: {
      "click": _vm.goAsso
    }
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('inline-svg', {
    class: _vm.assoNum > 0 ? 'bolt-icon' : 'bolt-icon-dis',
    attrs: {
      "src": require('../../assets/svg/bolt.svg').default
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("dictionary.box.association")))])]), _vm._v(" "), _c('div', {
    staticClass: "mischak",
    on: {
      "click": _vm.goPlay
    }
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('inline-svg', {
    staticClass: "mischak-svg",
    attrs: {
      "src": require('../../assets/svg/GameHalf.svg').default
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("dictionary.box.game")))])])]), _vm._v(" "), _c('div', {
    staticClass: "translations dicWord"
  }, [_c('div', {
    staticClass: "translate arbT"
  }, [_vm._v("\n          " + _vm._s(_vm.word.Eng) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "translate heb"
  }, [_vm._v("\n          " + _vm._s(_vm.word.heb) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [(!_vm.noSound) ? _c('button', {
    staticClass: "audioButton flex",
    attrs: {
      "disabled": !_vm.isLoadedAudio
    },
    on: {
      "click": _vm.playButton
    }
  }, [_c('img', {
    staticClass: "img-audio",
    attrs: {
      "src": _vm.speakerSvg,
      "alt": "audio"
    }
  })]) : _vm._e(), _vm._v(" "), _c('audio', {
    ref: "player"
  }, [_c('source', {
    attrs: {
      "src": _vm.audioSrc,
      "type": "audio/mp3"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.isAsso) ? _c('div', {
    staticClass: "assoBox"
  }, [_c('div', {
    staticClass: "arrows right-prev"
  }, [_c('button', {
    staticClass: "fillBtn",
    on: {
      "click": _vm.prevAsso
    }
  }, [_c('inline-svg', {
    class: _vm.currentAsso > 1 ? 'arrow-icon' : 'arrow-icon-dis',
    attrs: {
      "src": _vm.arrowIconPath.arrowIconPrevious
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "arrows left-next",
    on: {
      "click": _vm.nextAsso
    }
  }, [_c('button', {
    staticClass: "fillBtn"
  }, [_c('inline-svg', {
    class: _vm.currentAsso < _vm.assoNum ? 'arrow-icon' : 'arrow-icon-dis',
    attrs: {
      "src": _vm.arrowIconPath.arrowIcoNext
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "top-part-asso"
  }, [_c('div', {
    staticClass: "backIcon",
    on: {
      "click": function($event) {
        _vm.isAsso = false
      }
    }
  }, [_c('inline-svg', {
    attrs: {
      "src": require('../../assets/svg/back.svg').default
    }
  }), _vm._v(" "), _c('p')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "assoText"
  }, [_c('div', {
    staticClass: "heb"
  }, [_vm._v("\n          " + _vm._s(_vm.associations[_vm.currentAsso - 1]) + "\n        ")])])]) : _vm._e()]), _vm._v(" "), (_vm.isAsso) ? _c('div', {
    staticClass: "dotsDiv",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "dots",
    class: {
      dotHide: !(_vm.assoNum > 0),
      dotActive: _vm.currentAsso == 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dots",
    class: {
      dotHide: !(_vm.assoNum > 1),
      dotActive: _vm.currentAsso == 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dots",
    class: {
      dotHide: !(_vm.assoNum > 2),
      dotActive: _vm.currentAsso == 3
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAsso) ? _c('div', {
    staticClass: "addAssoBtn",
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t("dictionary.box.add_association")) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.sentences.length) ? _c('div', {
    staticClass: "box-headline"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("dictionary.box.example")) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.arabSen) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "arrows right-prev"
  }, [_c('button', {
    staticClass: "fillBtn",
    on: {
      "click": _vm.prevSen
    }
  }, [_c('inline-svg', {
    class: _vm.currentSen > 1 ? 'arrow-icon' : 'arrow-icon-dis',
    attrs: {
      "src": require("../../assets/svg/arrow-right.svg").default
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "arrows left-next",
    on: {
      "click": _vm.nextSen
    }
  }, [_c('button', {
    staticClass: "fillBtn"
  }, [_c('inline-svg', {
    class: _vm.currentSen < _vm.senNum ? 'arrow-icon' : 'arrow-icon-dis',
    attrs: {
      "src": require("../../assets/svg/arrow-left.svg").default
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "translations"
  }, [_c('div', {
    staticClass: "sens"
  }, [_c('div', {
    staticClass: "hebSen sentence uppercase"
  }, [_vm._v("\n          " + _vm._s(_vm.sentences[_vm.currentSen - 1].eng) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sentence"
  }, [_vm._v("\n          " + _vm._s(_vm.sentences[_vm.currentSen - 1].heb) + "\n        ")])]), _vm._v(" "), _c('button', {
    staticClass: "audioButton flex",
    class: {
      audioDis: !_vm.senAudioSrc
    },
    attrs: {
      "disabled": !_vm.senAudioSrc
    },
    on: {
      "click": _vm.playSenButton
    }
  }, [_c('img', {
    staticClass: "img-audio",
    class: {
      audioDis: !_vm.senAudioSrc
    },
    attrs: {
      "src": _vm.speakerSvg,
      "alt": "audio"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "senplayer"
  }, [_c('source', {
    attrs: {
      "src": _vm.senAudioSrc,
      "type": "audio/mp3"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("dictionary.box.suggest_association")) + "\n      ")]), _vm._v(" "), _c('v-card-text', [_c('textarea', {
    staticClass: "textBox",
    attrs: {
      "id": "addword",
      "name": "addword",
      "placeholder": _vm.placeholder
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("dictionary.box.send")) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018919e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dictionary/box.vue
// module id = 382
// module chunks = 0 5